






































































import Vue from 'vue';
import ResponsePagingInfo from '../../../../plugins/servicelayer/responseTypes/responsePagingInfo';
import GetSequenceNumberListRequestViewModel from '../../../../services/v1/viewModel/request/Sequencenumbers/GetSequenceNumberListRequestViewModel';
import SequenceNumberCreateRequestViewModel from '../../../../services/v1/viewModel/resource/SequenceNumberCreateRequestViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    newNumberSequence: new SequenceNumberCreateRequestViewModel(),
    editDialogVisible: false,
    requestError: undefined as any,
    filter: {
      searchCriteria: undefined as string | undefined,
    },
    columns: [] as {}[],
    list: {},
    pagination: {
      pageSize: 10,
      currentPage: 1,
    } as ResponsePagingInfo,
    innerPagination: {
      'paging.CurrentPage': undefined as number | undefined,
      'paging.PageSize': undefined as number | undefined,
      'paging.IncludeCount': undefined as boolean | undefined,
      'paging.NoPaging': undefined as boolean | undefined,
    },
  }),
  computed: {
    request() {
      return new GetSequenceNumberListRequestViewModel().fromModel({ ...this.filter, ...this.innerPagination });
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.pagination.currentPage = 1;
        this.innerPagination['paging.CurrentPage'] = 1;
        this.$debounce(() => {
          this.refreshList();
        }, 300, this)();
      },
    },
    request() {
      this.writeRequestToQuery();
    },
  },
  beforeMount() {
    this.getQueryFromRequest();
    this.pagination.currentPage = this.innerPagination['paging.CurrentPage']! ?? 1;
    this.pagination.pageSize = this.innerPagination['paging.PageSize']!;
  },
  mounted() {
    this.columns = [
      { value: '', field: 'filter' },
      { value: this.$t('core.page.sequencenumbers.list.name'), textAlign: 'left', field: 'name' },
      { value: this.$t('core.page.sequencenumbers.list.startNumber'), textAlign: 'right', field: 'startNumber' },
      { value: this.$t('core.page.sequencenumbers.list.increment'), textAlign: 'right', field: 'increment' },
      { value: this.$t('core.page.sequencenumbers.list.currentNumber'), textAlign: 'right', field: 'currentValue' },
    ];
  },
  methods: {
    getQueryFromRequest() {
      const queries = new GetSequenceNumberListRequestViewModel();
      queries.fromQuery(this.$routerUtils.getQueryParams());
      this.filter.searchCriteria = queries.searchCriteria;

      this.innerPagination['paging.CurrentPage'] = queries['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = queries['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = queries['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = queries['paging.NoPaging'];
    },
    async writeRequestToQuery() {
      this.$debounce(() => {
        this.$routerUtils.updateQueryParams(this.request.toQuery());
      }, 200, this.writeRequestToQuery)();
    },
    refreshList() {
      const sequenceList = this.$refs.sequenceList as any;
      sequenceList?.populateList();
    },
    populateData(params: any) {
      this.innerPagination['paging.CurrentPage'] = params.query['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = params.query['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = params.query['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = params.query['paging.NoPaging'];
      return this.$service.api.core.sequencenumbers.getSequenceNumberList(this.request);
    },
    showEditDialog() {
      this.newNumberSequence = new SequenceNumberCreateRequestViewModel();
      this.editDialogVisible = true;
    },
    async createSequence(newSequence: SequenceNumberCreateRequestViewModel) {
      try {
        await this.$service.api.core.sequencenumbers.createSequenceNumber(newSequence);
        this.refreshList();
        this.editDialogVisible = false;
      } catch (error: any) {
        this.requestError = error;
      }
    },
    async editSequence(id: number, currentStartNumber: number) {
      const newStartNumberInput = await this.$dialog.prompt(this.$t('core.page.sequencenumbers.editSequence.sequenceNumber'), this.$t('core.page.sequencenumbers.editSequence.newStartNumber'), currentStartNumber.toString());
      if (newStartNumberInput === null) {
        return;
      }
      let newStartNumber;
      try {
        newStartNumber = Number.parseInt(newStartNumberInput, 10);
      } catch (error: any) {
        this.$dialog.notify(this.$t('core.page.sequencenumbers.error.numberPlease'), this.$t('core.page.sequencenumbers.error.noNumber'));
        this.editSequence(id, currentStartNumber);
        return;
      }
      try {
        await this.$service.api.core.sequencenumbers.updateSequenceNumber(id, newStartNumber);
        this.refreshList();
      } catch (error: any) {
        this.$dialog.notify(this.$t('core.page.sequencenumbers.error.errorTitle'), error.message ?? error);
      }
    },
    async deleteSequence(id: number) {
      const confirmed = await this.$dialog.confirm(this.$t('core.page.sequencenumbers.deleteSequenceConfirmation.title'), this.$t('core.page.sequencenumbers.deleteSequenceConfirmation.confirmation'));
      if (!confirmed) {
        return;
      }

      try {
        await this.$service.api.core.sequencenumbers.deleteSequenceNumber(id);
        this.refreshList();
      } catch (error: any) {
        this.$dialog.notify(this.$t('core.page.sequencenumbers.error.errorTitle'), error.message ?? error);
      }
    },
  },
});
